import { orderBy } from 'lodash';
import { createSelector } from 'reselect';
import { RootState } from '../root.reducer';

export const selectTags = createSelector(
    (state: RootState) => Object.values(state.tags),
    (tags: any) => orderBy(tags, 'name')
)